import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// @mui
import {
  Box,
  Stack,
  Drawer,
  styled,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Divider,
  ListItemIcon,
} from "@mui/material";
// hooks
import useResponsive from "../../../hooks/useResponsive";
// config
import { NAV } from "../../../config-global";
// components
import Logo from "../../../components/logo";
import Scrollbar from "../../../components/scrollbar";
import { NavSectionVertical } from "../../../components/nav-section";
//
import navConfig from "./config-navigation";
import NavToggleButton from "./NavToggleButton";
import { PRIMARY } from "../../../theme/palette";
import Iconify from "../../../components/iconify/Iconify";
import { CustomAvatar } from "../../../components/custom-avatar";
import { useAuthContext } from "../../../sections/auth";

// ----------------------------------------------------------------------

NavVertical.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

const StyledRoot = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2, 2.5),
  borderTop: "1px solid #fff",
  position: "fixed",
  bottom: "0",
  left: "0",
  width: "100%",
  justifyContent: "flex-start",
  maxWidth: `${NAV.W_DASHBOARD}px`,
}));

const VerticalMenuList = styled("div")(({ theme }) => ({
  // height: "calc(100vh - 368px)",
  height: "100%",
  overflowY: "auto",
}));

export default function NavVertical({ openNav, onCloseNav }) {
  const { pathname } = useLocation();

  const [anchorEl, setAnchorEl] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const isDesktop = useResponsive("up", "lg");

  useEffect(() => {
    setIsSidebarOpen(false);
  }, []);

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
          borderRadius: "15px !important",
        },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          pt: 3,
          pb: 2,
          px: 2.5,
          flexShrink: 0,
          mx: "auto",
        }}
      >
        <Logo
          sx={{
            width: 80,
            maxWidth: 80,
            height: "auto",
            objectFit: "contain",
          }}
        />
      </Stack>

      <VerticalMenuList className="verticalMenuBox">
        <NavSectionVertical data={navConfig} />
      </VerticalMenuList>

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
      }}
    >
      <NavToggleButton />

      {isDesktop ? (
        <Drawer
          open={isSidebarOpen}
          variant="permanent"
          PaperProps={{
            sx: {
              zIndex: 0,
              width: NAV.W_DASHBOARD,
              bgcolor: `${PRIMARY.main} !important`,
              borderRightStyle: "dashed",
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
              background: `${PRIMARY.main} !important`,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
